class StoreSearch extends Component {

    /**
     * @param {HTMLDivElement} el
     * @property {HTMLFormElement} form
     * @property {HTMLDivElement[]} items
     * @property {HTMLInputElement} typeInput
     * @property {HTMLDivElement} full
     * @property {HTMLAnchorElement} buttonFull
     */
    constructor(el) {
        super(el);

        this.form = this.$find("form")
        this.items = this.$findAll('.StoreSearch-storeTypeItem');
        this.typeInput = this.$find('#type');

        /** @type {boolean} */
        const isSearchFull = el.dataset.isSearchFull === "1"

        this.full = this.$find('#full');
        this.buttonFull = this.$find('#buttonFull');

        if (isSearchFull) {
            this.activateFullSearch();
        } else {
            this.buttonFull.addEventListener('click', e => {
                e.preventDefault();
                this.activateFullSearch();
            })
        }

        this.addEventListeners();
    }

    activateFullSearch() {
        this.full.classList.add('active');
        this.buttonFull.style.display = 'none';
    }

    selectType(storeTypeId) {
        this.typeInput.value = storeTypeId;
    }

    addEventListeners() {
        this.items.forEach(item => {
            item.addEventListener('click', () => {
                const storeTypeId = item.dataset.storeTypeId;

                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                    this.typeInput.value = '';
                } else {
                    item.classList.add('active');
                    this.selectType(storeTypeId);
                }

                this.form.submit();
            });
        });
    }

}
